import React from "react";
import AnchorLink from 'react-anchor-link-smooth-scroll';

const Header = () =>{
    return(
        <header>
            <div>
                <h1>
                    Paolo Trapu  
                </h1>
                <h2>
                    Développeur Front   
                </h2>
            </div>
            <AnchorLink className="link" href='#about'></AnchorLink>
        </header>
    );
}

export default Header;
